import { render, staticRenderFns } from "./xcoop.vue?vue&type=template&id=ada3a44c&scoped=true&"
import script from "./xcoop.vue?vue&type=script&lang=js&"
export * from "./xcoop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada3a44c",
  null
  
)

export default component.exports